import { createAction } from 'typesafe-actions';
import { TwitchUserInfo, TwitchVideo } from '@lib/domain/twitch';
import { createActionTypePrefixFormat } from '../common';
import { TwitchOverviewOrder, TwitchCompleteOrder } from '../Twitch/types';

const typePrefixFormat = createActionTypePrefixFormat('Twitch');

/* ------------- action creators ------------- */
export const setTwitchUser = createAction(
    typePrefixFormat('SET_TWITCH_USER'),
    (user: TwitchUserInfo) => ({
        user,
    }),
)();

export const setTwitchPosts = createAction(
    typePrefixFormat('SET_TWITCH_POSTS'),
    (posts: TwitchVideo[]) => ({
        posts,
    }),
)();

export const setTwitchOverviewOrder = createAction(
    typePrefixFormat('SET_TWITCH_OVERVIEW_ORDER'),
    (order: TwitchOverviewOrder) => ({
        order,
    }),
)();

export const setTwitchCompleteOrder = createAction(
    typePrefixFormat('SET_TWITCH_COMPLETE_ORDER'),
    (order: TwitchCompleteOrder) => ({
        order,
    }),
)();

export const resetTwitchData = createAction(
    typePrefixFormat('RESET_TWITCH_DATA'),
    () => null,
)();

export const setTwitchHourDuration = createAction(
    typePrefixFormat('SET_TWITCH_HOUR_DURATION'),
    (time: number) => ({
        time,
    }),
)();
export type TwitchActions = ReturnType<
    | typeof setTwitchUser
    | typeof setTwitchPosts
    | typeof setTwitchOverviewOrder
    | typeof setTwitchCompleteOrder
    | typeof resetTwitchData
    | typeof setTwitchHourDuration
>;
